import type { MediaCountSummary } from "@/api/types";
import { Button } from "@/components/ui";

interface MediaCountTruthProps {
  summary: MediaCountSummary;
  loaded: number;
  loadingMore: boolean;
  onLoadMore: () => void;
}

/** Keeps the aggregate truth separate from the bounded page in memory. */
export function MediaCountTruth({ summary, loaded, loadingMore, onLoadMore }: MediaCountTruthProps) {
  return (
    <div className="media-pagination" aria-label="Medya sayımı">
      <span className="muted">
        {loaded} / {summary.total} gösteriliyor
      </span>
      {loaded < summary.total && (
        <Button busy={loadingMore} onClick={onLoadMore}>
          Daha fazla yükle
        </Button>
      )}
    </div>
  );
}
